import { SBProps } from '../../../../utils';
import { SBCareerOfferProps } from '../types';

export const CareerOfferSchema = ({ blok }: SBProps<SBCareerOfferProps>) => {
  const {
    title,
    first_published_at,
    seoDescription,
    seoEmploymentType,
    seoBaseSalary,
    seoBaseSalaryRange,
    seoUnitText,
  } = blok;

  const jobPostingSchema = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    datePosted: first_published_at || new Date().toISOString(),
    title: title || '',
    description: seoDescription || title || '',
    employmentType: seoEmploymentType || 'FULL_TIME',
    industry: 'IT',
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: 'PLN',
      value: seoBaseSalaryRange
        ? {
            '@type': 'QuantitativeValue',
            unitText: seoUnitText || 'MONTH',
            minValue: Number(seoBaseSalary) || 0,
            maxValue: Number(seoBaseSalaryRange) || 0,
          }
        : {
            '@type': 'QuantitativeValue',
            unitText: seoUnitText || 'MONTH',
            value: Number(seoBaseSalary) || 0,
          },
    },
    hiringOrganization: {
      '@type': 'Organization',
      name: 'Naturaily',
      sameAs: 'www.naturaily.com',
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'Poland',
        addressLocality: 'Wrocław',
        postalCode: '50-069',
        streetAddress: 'Ofiar Oświęcimskich 17',
      },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jobPostingSchema) }}
    />
  );
};
